import { nullable, number, object, string, type InferOutput } from 'valibot'

import { type DispatchListDetailShipmentOrderExEntity } from '@/libs/api'

/**
 * 配送依頼（shipmentOrder）の編集用フォームの値
 */
export const updateShipmentOrderFromValueSchema = object({
  /** 配送依頼No - ※手入力配送依頼のみ更新対象 */
  orderNo: string(),
  /** 配送依頼ID */
  id: number(),
  /** 備考 */
  note: string(),
  /** 荷姿ID - ※手入力配送依頼のみ更新対象 */
  packageCategoryId: nullable(number()),
  /** 荷姿数 - ※手入力配送依頼のみ更新対象 */
  packageCount: nullable(number()),
  /** 重量(kg) - ※手入力配送依頼のみ更新対象 */
  weight: nullable(number()),
  /** 個数 - ※手入力配送依頼のみ更新対象 */
  quantity: nullable(number()),
  /** 請求運賃(円) - ※手入力配送依頼のみ更新対象 */
  income: nullable(number()),
  /** 発時間制限(開始) */
  departureTimeRestrictionStart: nullable(string()),
  /** 発時間制限(終了) */
  departureTimeRestrictionEnd: nullable(string()),
  /** 着時間制限(開始) */
  arrivalTimeRestrictionStart: nullable(string()),
  /** 着時間制限(終了) */
  arrivalTimeRestrictionEnd: nullable(string())
})

/**
 * 配送依頼（shipmentOrder）の編集用フォームの値
 */
export type UpdateShipmentOrderFromValue = InferOutput<
  typeof updateShipmentOrderFromValueSchema
>

/**
 * 配送依頼（shipmentOrder）の編集用フォームの値に変換
 */
export const mapToUpdateShipmentOrderFormValue = ({
  shipmentOrder
}: {
  shipmentOrder: DispatchListDetailShipmentOrderExEntity
}): UpdateShipmentOrderFromValue => ({
  orderNo: shipmentOrder.orderNo,
  note: shipmentOrder.note ?? '',
  packageCategoryId: shipmentOrder.group.packageCategoryId ?? null,
  packageCount: shipmentOrder.packageCount ?? null,
  weight: shipmentOrder.weight ? shipmentOrder.weight : null,
  quantity: shipmentOrder.quantity ?? null,
  income: shipmentOrder.income,
  id: shipmentOrder.id,
  departureTimeRestrictionStart: shipmentOrder.departureTimeRestrictionStart,
  departureTimeRestrictionEnd: shipmentOrder.departureTimeRestrictionEnd,
  arrivalTimeRestrictionStart: shipmentOrder.arrivalTimeRestrictionStart,
  arrivalTimeRestrictionEnd: shipmentOrder.arrivalTimeRestrictionEnd
})
